import { DataPoint, trace } from '~/services/analyticsService'
import { useUser } from './user/useUser'

export function useTracer() {
  const { user_id, name, email, role } = useUser()

  const traceWithUserInfo = (point: Omit<DataPoint, 'client_id'> | string) => {
    const dataPoint = (typeof point === 'string' ? { event: point } : point) as DataPoint

    const labels = {
      ...dataPoint.labels,
      user_id: user_id.toString(),
      name: name,
      email: email,
      role: role
    }

    return trace({
      ...dataPoint,
      labels
    })
  }

  return traceWithUserInfo
}
